import { Button, Dialog, Text } from '@noorden-insurtech/alba-design-system';
import { Ban } from 'lucide-react';

interface CancelProposalDialogProps {
  isOpen: boolean;
  isLoading?: boolean;
  proposerName?: string;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
}

export function CancelProposalDialog({
  isOpen,
  isLoading = false,
  proposerName,
  onClose,
  onConfirm,
}: CancelProposalDialogProps) {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={details => {
        if (!details.open && !isLoading) onClose();
      }}
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content className='w-[640px] max-w-[90vw] rounded-[24px] bg-[#F9F9F9] p-0 shadow-xl'>
          <div className='flex flex-col items-start gap-4 p-6'>
            <Dialog.Header className='w-full p-0'>
              <Dialog.Title className='w-full'>
                <div className='flex w-full items-center justify-between gap-3'>
                  <div className='flex items-center gap-2'>
                    <Ban className='h-6 w-6 text-alba-black-500' />
                    <Text className='text-lg font-bold text-alba-black-500'>
                      Cancelar proposta
                    </Text>
                  </div>
                  <Dialog.CloseButton onClick={onClose} />
                </div>
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body className='w-full p-0'>
              <div className='flex flex-col items-start gap-2 w-full'>
                <Text className='text-sm text-alba-gray-600'>
                  {proposerName
                    ? `Deseja cancelar a proposta de ${proposerName}?`
                    : 'Deseja cancelar esta proposta?'}
                </Text>
                <Text className='text-sm text-alba-gray-600'>
                  O status passa a ser Proposta cancelada. A proposta deixa de
                  poder ser editada, assinada ou transmitida.
                </Text>
              </div>
            </Dialog.Body>

            <Dialog.Footer className='w-full p-0'>
              <div className='flex w-full items-center justify-end gap-6'>
                <Dialog.CloseTrigger asChild>
                  <Button variant='ghost' size='large' disabled={isLoading}>
                    Voltar
                  </Button>
                </Dialog.CloseTrigger>
                <Button
                  variant='primary'
                  size='large'
                  loading={isLoading}
                  disabled={isLoading}
                  onClick={onConfirm}
                >
                  Confirmar cancelamento
                </Button>
              </div>
            </Dialog.Footer>
          </div>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
